import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";
import * as eDepositSelectors from "../../../../../selectors/e-deposit.js";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import DepositManualPaymentItem from "../../../components/DepositManualPaymentItem";
import DepositOnlinePaymentItem from "../../../components/DepositOnlinePaymentItem";
import CustomEmptyFont from "../../../../../components/CustomEmptyFont";
import clsx from "clsx";
import constants from "../../../../../constants";
import {getEDepositAdditionalChargeFullText, getEDepositClientCode} from "../../../../../selectors/e-deposit.js";
import * as setOffSelectors from "../../../../../selectors/set-off";
function ViewDocumentModal({ show, handleClose, data, onSubmitSetOff, onClickViewDocument, loading, onClickDeleteFunction }) {
  // const statementData = _.get(data, ["data", "data"], null);
  const clientCode = eDepositSelectors.getEDepositClientCode(data);
  const clientRemark = eDepositSelectors.getEDepositClientRemark(data);
  const depositAmount = eDepositSelectors.getEDepositDepositAmount(data);
  const totalText = eDepositSelectors.getEDepositTotalText(data);
  const reference = eDepositSelectors.getEDepositReference(data);
  const statusText = eDepositSelectors.getEDepositStatusText(data);
  const statusValue = eDepositSelectors.getEDepositStatusValue(data);
  const typeText = eDepositSelectors.getEDepositTypeText(data);
  const manualPaymentItems = eDepositSelectors.getEDepositManualPaymentItems(data);
  const onlinePaymentItem = eDepositSelectors.getEDepositOnlinePaymentItems(data);
  const additionalCharges = eDepositSelectors.getEDepositAdditionalChargeFullText(data);
  const isCancellable = setOffSelectors.getSubmittedContractIsCancellable(data);
  const cancelLink = setOffSelectors.getSubmittedContractCancelLink(data);

  const onClickDelete = (url) => {
    onClickDeleteFunction(url);
  };

  return (
    <Modal show={show} size="xl" onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>Deposit Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6} xs={12}>
            <p>
              Type: <span>{typeText}</span>
            </p>
          </Col>
          <Col md={6} xs={12}>
            <p>
              Reference Number: <span style={{ wordBreak: "break-word" }}>{reference}</span>
            </p>
          </Col>
          <Col md={6} xs={12}>
            <p>
              Client Code: <span>{clientCode}</span>
            </p>
          </Col>
          <Col md={6} xs={12}>
            <p>
              Status:{" "}
              <span
                  className={clsx("status-span ", {
                    ["pending-color"]: _.isEqual(constants.STATUS_PAYMENT_PENDING, statusValue),
                    ["successful-color"]:
                    _.isEqual(constants.STATUS_PAYMENT_PAYMENT_MADE, statusValue) ||
                    _.isEqual(constants.STATUS_PAYMENT_APPROVED, statusValue),
                    ["error-color"]:
                    _.isEqual(constants.STATUS_PAYMENT_CANCELLED, statusValue) ||
                    _.isEqual(constants.STATUS_PAYMENT_ERROR, statusValue) ||
                    _.isEqual(constants.STATUS_PAYMENT_REJECTED, statusValue),
                  })}
              >
                {statusText}
              </span>
            </p>
          </Col>
          <Col md={12} xs={12}>
            <p>Total Deposit Amount: {totalText}</p>
          </Col>
          <Col md={12} xs={12}>
            <p>
              <span>Client Remark:</span> <CustomEmptyFont variant="span" value={clientRemark} />
            </p>
          </Col>
        </Row>
        {manualPaymentItems
          ? _.map(manualPaymentItems, (item, index) => {
              return (
                <DepositManualPaymentItem
                  key={index}
                  onClickViewDocument={onClickViewDocument}
                  item={item}
                  index={index}
                />
              );
            })
          : false}
        {onlinePaymentItem ? <DepositOnlinePaymentItem item={onlinePaymentItem} /> : false}

        <div className="d-flex justify-content-end my-3 mr-3">

          <button className={clsx("btn custom-button-back")}  onClick={(e)=>{
            e.preventDefault()
            handleClose()
          }}>
            Close
          </button>
          {isCancellable ? <button
              className={clsx("btn custom-button-white")}
              onClick={(e)=>{
                e.preventDefault()
                onClickDelete(cancelLink)
              }}
              // disabled={!isCancellable}
          >
            Cancel
          </button>:false}
        </div>

        <LoadingOverlay loading={loading}></LoadingOverlay>
      </Modal.Body>
    </Modal>
  );
}

export default ViewDocumentModal;
